import { css } from "lit";

export const styles = css`
  .containers {
    height: 100%;
  }

  .live-events-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .main-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1;
    min-height: 0;
  }

  .filter-buttons {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    flex-shrink: 0;
  }

  .empty-state {
    text-align: center;
    padding: 64px 24px;
    color: var(--sds-color-text-default-secondary);
  }

  .empty-state ph-video-camera {
    color: var(--sds-color-text-default-tertiary);
    margin-bottom: 16px;
  }

  .empty-state h2 {
    font: var(--sds-typography-weight-semibold) var(--sds-typography-scale-04) var(--sds-typography-family-title);
    margin: 0 0 8px 0;
    color: var(--sds-color-text-default-primary);
  }

  .empty-state p {
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    margin: 0 0 24px 0;
  }

  .loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 64px 24px;
    color: var(--sds-color-text-default-secondary);
  }

  .events-list {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
  }

  .event-card {
    background: var(--sds-color-background-default-tertiary);
    overflow: hidden;
    flex-shrink: 0;
  }

  .event-thumbnail {
    display: block;
    width: 100%;
    height: auto;
    aspect-ratio: 27 / 14;
  }

  .event-content {
    padding: 20px;
  }

  .event-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    gap: 12px;
  }

  .event-header h3 {
    font: var(--sds-typography-weight-semibold) var(--sds-typography-scale-03) var(--sds-typography-family-title);
    margin: 0;
    color: var(--sds-color-text-default-primary);
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .event-header-actions {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .event-actions {
    display: flex;
  }

  .event-description {
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
    margin: 0 0 12px 0;
  }

  .event-meta {
    display: flex;
    align-items: start;
    justify-content: space-between;
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-01) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
  }

  .meta-item strong {
    font-weight: var(--sds-typography-weight-medium);
    color: var(--sds-color-text-default-primary);
  }

  .streaming-buttons {
    display: flex;
    align-items: stretch;
    gap: 8px;
  }

  .streaming-buttons wow-button {
    display: flex;
  }

  .delete-confirmation-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 0;
  }

  .delete-confirmation-content p {
    margin: 0;
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
  }
  .confirmation-buttons {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-400);
    padding: var(--sds-size-space-300);
  }

  @media (max-width: 768px) {
    .filter-buttons {
      justify-content: flex-start;
      overflow-x: auto;
      flex-wrap: nowrap;
      padding-bottom: 4px;
    }

    .filter-buttons wow-button {
      flex-shrink: 0;
    }

    .event-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }

    .event-header h3 {
      white-space: normal;
      overflow-wrap: anywhere;
    }

    .event-header-actions {
      width: 100%;
      justify-content: space-between;
    }

    .event-thumbnail {
      width: 100%;
      height: auto;
    }

    .event-content {
      padding: 16px;
    }

    .event-meta {
      flex-direction: column;
      gap: 8px;
      align-items: flex-start;
    }
  }
`;
